import { combineReducers } from "redux";
import {
  getVerifyManualTransactionReducer,
  postQrInitManualReducer,
  getQrManualCheckReducer,
} from "./transaction";
import {
  warningModalReducer,
  getRedictionalUrl,
  languageSelectorReducer,
} from "./warningModal";

const rootReducer = combineReducers({
  getVerifyManualTransactionReducer: getVerifyManualTransactionReducer,
  postQrInitManualReducer: postQrInitManualReducer,
  getQrManualCheckReducer: getQrManualCheckReducer,

  warningModalReducer: warningModalReducer,
  getRedictionalUrl: getRedictionalUrl,
  languageSelectorReducer: languageSelectorReducer,
});

export default rootReducer;
